module.exports = __webpack_public_path__ + "img/th_TH.9f9dc74.webp";